<template>
    <div class="Header">
        <div class="Header-black flexSp" v-if="false">
            <div class="Header-logo" @click="$router.push('/home')">
                <img class="login-Mb" :src="require('@/assets/images/logo2.png')" alt="华馥科技有限公司" height="50px" />
                <img class="login-Pc" :src="require('@/assets/images/logo1-pc.png')" alt="华馥科技有限公司" height="40px" />
            </div>
            <div class="flexAlign">
                <div class="Header-menu">
                    <Menu :isBlack="false" />
                </div>
            </div>
            <div class="lang-user-pc flexAlign">
                <div class="lang flexAlign" @click="selectLang">
                    <img :src="require('@/assets/images/lang-white.png')" alt="" />
                    <div>{{ currentLang }}</div>
                </div>
                <div class="user" @click="toLogin">
                    <div><i class="el-icon-s-custom"></i></div>
                    <div>{{ $t("meun.login") }}</div>
                </div>
            </div>
        </div>

        <div class="Header-white" v-if="true">
            <div class="Header-logo" @click="$router.push('/home')">
                <img class="login-Mb" :src="require('@/assets/images/logo1.png')" height="40px" alt="华馥科技有限公司" />
                <img class="login-Pc" :src="require('@/assets/images/logo2-pc.png')" height="28px" alt="华馥科技有限公司" />
            </div>
            <div class="flexAlign flex1">
                <div class="Header-menu">
                    <Menu :isBlack="false" />
                </div>
            </div>
            <div class="lang-user-pc flexAlign">
                <!-- <div class="lang flexAlign" @click="selectLang">
                    <img :src="require('@/assets/images/lang-black.png')" alt="" />
                    <div>{{ currentLang }}</div>
                </div> -->
                <!-- <div class="user" @click="toLogin">
                    <div><i class="el-icon-s-custom"></i></div>
                    <div>{{ $t("meun.login") }}</div>
                </div> -->
                <el-button @click="toLogin" type="primary" round style="">碳和云平台</el-button>
                <el-tooltip placement="bottom">
                    <div slot="content" class="experience">
                        <p class="head">
                            <img class="qrcode" :src="require('@/assets/images/fixed/小程序码.jpg')" width="125px"
                                height="125px" alt="">
                        </p>
                        <div class="body">扫码体验微信小程序</div>
                    </div>
                    <!-- <div class="item flex-column">
                        <img class="unhover" :src="require('@/assets/images/fixed/二维码.png')" width="18px" height="18px"
                            alt="">
                        <img class="hover" :src="require('@/assets/images/fixed/二维码-hover.png')" width="18px"
                            height="18px" alt="">
                        <span class="text">小程序</span>
                    </div> -->
                    <el-button round style="">小程序</el-button>
                </el-tooltip>
            </div>
        </div>
    </div>
</template>

<script>
import Menu from "./menu";
export default {
    components: {
        Menu,
    },
    data() {
        return {
            showBlack: true,
            showWhite: false,
            currentLang: "",
        };
    },

    mounted() {
        window.addEventListener("scroll", this.handleScroll);
        this.showProfile = true;
        this.currentLang =
            localStorage.getItem("lang") == "en" ? "English" : "中文";
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        handleScroll() {
            const distanceToTop = window.scrollY;
            if (distanceToTop < 100) {
                this.showBlack = true;
                this.showWhite = false;
            } else {
                this.showBlack = false;
                this.showWhite = true;
            }
        },
        toLogin() {
            window.open("https://new.huafune.com", "_blank");
        },
        selectLang() {
            if (this.currentLang == "English") {
                this.$i18n.locale = "zh";
                localStorage.setItem("lang", "zh"); // 这样页面刷新就不会改变选择的语言了
                this.currentLang = "中文";
            } else {
                this.$i18n.locale = "en";
                localStorage.setItem("lang", "en"); // 这样页面刷新就不会改变选择的语言了
                this.currentLang = "English";
            }
            window.location.reload();
        },
    },
};
</script>

<style lang="scss" scoped>
.Header {
    position: sticky;
    top: 0;
    z-index: 999;
}

.Header-black {
    width: 100%;
    height: 80px;
    background-color: rgba(0, 0, 0, 0.35);
    // position: fixed;
    // top: 0;
    // z-index: 20;
    padding: 0 0 0 30px;
    border-bottom: 1px;

    .box-center {
        height: 100%;
    }

    .Header-logo {
        cursor: pointer;
    }

    .lang {
        color: #fff;
        cursor: pointer;

        img {
            margin-right: 4px;
        }
    }

    .user {
        background: #182547;
        padding: 20px 50px;
        text-align: center;
        margin-left: 20px;
        color: #fff;
        cursor: pointer;
    }
}

.Header-white {
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-bottom: 1px solid #e6e6e6;
    width: 100%;
    height: 60px;
    background-color: #fff;
    // position: fixed;
    // top: 0;
    // z-index: 20;
    padding: 0 0 0 30px;

    .box-center {
        height: 100%;
    }

    .Header-logo {
        cursor: pointer;
    }

    .lang {
        cursor: pointer;

        img {
            margin-right: 4px;
        }
    }

    .user {
        background: #182547;
        padding: 10px 40px;
        text-align: center;
        margin-left: 20px;
        color: #fff;
        cursor: pointer;
    }
}

@media screen and (min-width: 980px) {
    .lang-user-pc {
        display: flex;
    }

    .login-Pc {
        display: block;
    }

    .login-Mb {
        display: none;
    }
}

@media screen and (max-width: 980px) {
    .Header-white {
        padding-left: 10px;
        justify-content: space-between;
    }

    .lang-user-pc {
        display: none;
    }

    .login-Pc {
        display: none;
    }

    .login-Mb {
        display: block;
    }
    .flex1 {
        flex: 1;
    }
    .Header-menu {
        width: 100%;
    }
}

.experience {
    .head {
        margin-bottom: 6px;
    }

    .body {
        text-align: center;
        font-size: 12px;
    }
}
</style>
